// Stimulus controllers, registered by hand — do NOT run
// `bin/rails stimulus:manifest:update`, it regenerates this file from the
// directory and drops the registerFire lines below with it.

import { application } from "./application";
import { registerFire } from "@fire/register";
import { registerFireInputs } from "@fire/register-inputs";
import { registerFireBridge } from "@fire/register-bridge";
import { registerJane } from "@jane/register";
import PeelController from "./peel_controller";
import NearController from "./near_controller";
import FonifController from "./fonif_controller";
import ScanController from "./scan_controller";
import SheetController from "./sheet_controller";
import FilterController from "./filter_controller";
// fire's map (fire/docs/MAPS.md § The controller); needs maplibre-gl.
import MapController from "@fire/map_controller";
import PinController from "@fire/pin_controller";

// Everything fire ships, in one line each (fire/docs/HOTWIRE.md).
registerFire(application);
registerFireInputs(application); // the masked fields (imask): the card number's groups, money, phone
registerFireBridge(application);
registerJane(application);

// This app's own. walk/HOME.md (the fold) · walk/DONATE.md (near me) · walk/WELCOME.md (scan) · walk/ORG.md (the sheet, the dock's Mais).
application.register("peel", PeelController);
application.register("near", NearController);
application.register("fonif", FonifController);
application.register("scan", ScanController);
application.register("sheet", SheetController);
application.register("filter", FilterController);
application.register("map", MapController);
application.register("pin", PinController);
